const support = (function() {
    if (!window.DOMParser) {
        return false;
    }
    const parser = new DOMParser();
    try {
        parser.parseFromString('x', 'text/html');
    } catch (err) {
        return false;
    }
    return true;
}());

const textToHTML = function(str) {

    // check for DOMParser support
    if (support) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(str, 'text/html');
        return doc.body.children[0];
    }

    // Otherwise, create div and append HTML
    const dom = document.createElement('div');
    dom.innerHTML = str;
    return dom;

};


function webinars() {
    if (document.querySelector('div.upcoming') === null) {
        if (!window.webinarTitle || !window.upcomingWebinars) {
            return;
        }
        const Webinars = window.upcomingWebinars;
        Object.keys(Webinars).map((streamID) => {
            const stream = document.querySelector(`.listing-page.stream-${streamID}`);
            if (stream) {
                const title = window.webinarTitle ? window.webinarTitle : '';
                const newHTML = `<div id="upcoming" class="upcoming">
                            <h3 class="upcoming-title">${title}</h3>
                            <div id="upcoming-box" class="upcoming-box">
                            </div>
                        </div>`;
                if (document.querySelector('div.description-block ')) {
                    document.querySelector('div.description-block ').insertAdjacentHTML('beforebegin', newHTML);
                }
                const section = Webinars[streamID];
                section.forEach((item) => {
                    const tile = `<div class="item-next">
                            <div class="next-label">
                                <p>${item.label}</p>
                            </div>
                            <div class="next-date">
                                <span>${item.Date}</span>
                            </div>
                            <div class="next-link">
                                <a href="${item.link}">${item.text}</a>
                            </div>
                        </div>`;
                    if (document.querySelector('.upcoming .upcoming-box')) {
                        document.querySelector('.upcoming .upcoming-box').insertAdjacentHTML('beforeend', tile);
                    }
                });
            }
            return stream;
        });
    }
}

function streambanners() {
    const bannerSettings = window.streams.BannerSettings;
    Object.keys(bannerSettings).map((streamID) => {
        const stream = document.querySelector(`.listing-page.stream-${streamID}`);
        if (stream) {
            const bgImg = bannerSettings[streamID].bgPath;
            const mobilebg = bannerSettings[streamID].mobileBgColor;
            const title = bannerSettings[streamID].title;
            const mobiletitle = bannerSettings[streamID].mobileTitle;
            const subtitle = bannerSettings[streamID].subtitle;
            const colorCode = bannerSettings[streamID].colorCode;

            if (bgImg !== '' && bgImg !== undefined) {
                document.querySelector('.header-wrapper').style.backgroundImage = "url(" + bgImg + ")";
                document.querySelector('.header-wrapper').style.backgroundRepeat = "no-repeat";
                document.querySelector('.primary-logo img').setAttribute('src', bgImg);
            }
            if (mobilebg !== '' && mobilebg !== undefined && window.outerWidth <= 991) {

                document.querySelector('.header-wrapper').setAttribute('style', 'background-color: #' + mobilebg);
            }
            if (mobiletitle !== '' && mobiletitle !== undefined && window.outerWidth <= 415) {
                document.querySelector('.header-intro h2').innerHTML = mobiletitle;
                document.querySelector('.header-intro h2').style.color = colorCode;
            } else if (title !== '' && title !== undefined) {
                document.querySelector('.header-intro h2').innerHTML = title;
                document.querySelector('.header-intro h2').style.color = colorCode;
            }
            if (subtitle !== '' && subtitle !== undefined) {
                if (document.querySelector('p.head-description') === null) {
                    const description = document.createElement('p');
                    description.classList.add('head-description');
                    description.innerHTML = subtitle;
                    description.style.color = colorCode;
                    document.querySelector('.header-intro h2').insertAdjacentElement('afterend', description);
                }
            }
        }
        return stream;
    });
}

function sortNewToOld(tilesArray) {
    const sortedArr = tilesArray.sort(function(a, b) {
        return new Date(b.getAttribute('data-sort-time')) - new Date(a.getAttribute('data-sort-time'));
    });
    // Remove hidden class on any CTA tiles to make sure they're shown
    sortedArr.forEach((arrItem) => {
        if (arrItem.classList.contains('cta')) {
            arrItem.classList.remove('hide');
        }
    });
    return sortedArr;
}

function handleTileSorting(event) {
    let sortedArray = [];
    const activeRadioValue = event.currentTarget.getAttribute('value');
    const tileListContainer = document.querySelector('ul.clearfix');
    const tilesArray = [...document.querySelectorAll('.tile')];
    // Loop through tiles, grab timestamp, and add to li element as a data attribute for easier element sorting
    tilesArray.forEach((tile) => {
        const timeTag = tile.getElementsByTagName('abbr')[0];
        if (timeTag !== undefined) {
            const timestamp = timeTag.getAttribute('title');
            tile.setAttribute('data-sort-time', timestamp);
        }
    });

    // Check radio value and sort accordingly
    if (activeRadioValue === 'recent') {
        sortedArray = sortNewToOld(tilesArray);
    }

    // Clear the container and append new sorted tiles array
    tileListContainer.innerHTML = '';
    sortedArray.forEach((arrayItem) => {
        tileListContainer.appendChild(arrayItem);
    });
}

function filters() {
    const filter = '<div class="filter-category">' +
        '<label for="Category" class="category-label">Filter:</label>' +
        '<button type="button" class="navbar-dropdown-toggle is-focusable has-toggle-label" aria-haspopup="true" aria-expanded="false" aria-controls="uf-dropdown-2">' +
        '<span class="dropdown-inset-label inline uf-menu-item">' +
        '<span class="sr-only">Toggle submenu for:</span> Category' +
        '</span>' +
        '<i class="fas fa-chevron-down" aria-hidden="true"></i>' +
        '</button>' +
        '<form id="onBrand__filter--form">' +
        '<ul id="dropdown-2" class="submenu navbar-dropdown category-dropdown" role="menu" aria-label="Category">' +
        '</ul>' +
        '</form>' +
        '</div>';
    document.querySelector('div.description-block').appendChild(textToHTML(filter));

    const categoryArray = window.obData.category.Streams;
    categoryArray.forEach((category) => {
        const checkboxContainer = document.createElement('li');
        checkboxContainer.classList.add('submenu-list-item');
        const checkbox = document.createElement('input');
        checkbox.setAttribute('type', 'radio');
        checkbox.setAttribute('id', category.title);
        checkbox.value = category.streamId;
        checkbox.className = category.title;
        checkbox.name = category.title + 'sort';
        checkbox.addEventListener('change', handleTileSorting, this);
        const checkboxLabel = document.createElement('label');
        const checkboxLabelText = document.createTextNode(category.title);
        checkboxLabel.appendChild(checkboxLabelText);
        checkboxLabel.setAttribute('for', category.title);
        checkboxContainer.appendChild(checkbox);
        checkboxContainer.appendChild(checkboxLabel);
        document.querySelectorAll('ul.category-dropdown')[0].appendChild(checkboxContainer);
    });
}

function newIcon() {
    const newicon = document.createElement('div');
    newicon.classList.add('new-icon');
    newicon.innerHTML = 'New';
    const featuredTile = document.querySelector('li.highlight');
    if (featuredTile && featuredTile.querySelector('p.custom-tile-label') === null) {
        const ptag = '<p class= "custom-tile-label"></p>';
        if (featuredTile.querySelector('.friendly-timestamp')) {
            featuredTile.querySelector('.friendly-timestamp').insertAdjacentHTML('afterend', ptag);
        }
    }
    if (featuredTile) {
        if (featuredTile.querySelector('p.custom-tile-label')) {
            featuredTile.querySelector('p.custom-tile-label').innerHTML = 'Featured';
        }
        featuredTile.insertAdjacentElement('afterbegin', newicon);
    }

    const Icons = window.NewIcon.Colors;
    Object.keys(Icons).map((streamID) => {
        const stream = document.querySelector(`.listing-page.stream-${streamID}`);
        if (stream) {
            const colorCode = Icons[streamID].colorcode;
            if (
                colorCode === '' &&
                colorCode === undefined
            ) {
                throw new ReferenceError('Error in custom New Icon settings');
            } else {
                featuredTile.querySelector('div.new-icon').style.backgroundColor = colorCode;
            }
        }
        return stream;
    });
}

function replaceAsFeaturedTile() {
    const tile = document.querySelector('.tile:first-of-type');
    const placeOne = document.getElementById('upcoming');
    const placeTwo = document.querySelector('.description-block');
    const ul = document.createElement('ul');
    ul.classList.add('featuredTile');
    ul.appendChild(tile);
    if (placeOne) {
        $(ul).insertBefore(placeOne);
    } else if (placeTwo) {
        $(ul).insertBefore(placeTwo);
    }
}
const checkElement = async(selector) => {
    while (document.querySelector(selector) === null) {
        await new Promise((resolve) => requestAnimationFrame(resolve));
    }

    return document.querySelector(selector);
};

function handleHighlightTile() {
    checkElement('#collection-items .tile.highlight').then(() => {
        // Check that an existing tile isn't hiding
        const activeHighlightItem = document.querySelectorAll('#collection-items .tile.highlight');

        // If we find it, remove the class
        if (activeHighlightItem) {
            activeHighlightItem.forEach((active) => {
                active.classList.remove('highlight');
            });
        }

    });
}
export { webinars, streambanners, filters, newIcon, replaceAsFeaturedTile, handleHighlightTile };


// WEBPACK FOOTER //
// ./script-partials/upcomingWebinar.js